import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getCookie, setCookie } from '@beef/utils';
import { Accumulator, AccumulatorList as CommonAccumulatorList, dispatchHideGiftAccumulatorEvent, elkPlanBUnlimAccum3HoursEnabled, getAccumulatorTextContent, getAccumulatorVariant, getUnlimitedAccumulatorButtonType } from '@beef/elk-common';
import { useCustomEvent } from '@beef/elk-common/hooks';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { UNLIM_MODAL, UnlimThreeStatus } from '@beef/elk-common/constants';
import { getHasGiftAccumulator } from "../../../../utils/accumulators";
import { fubMetricSideMenu } from "../../../../utils/metric";
import { UnlimitedAppModal } from "../../../UnlimitedAppModal";
import { GIFT_VIEW_COOKIE } from "../constants/accumulators";
import { selectAccountType } from "../store/selectors";
import { selectAccumMainCtn, selectAccumService, selectHasTetheringUnlimit, selectIsAccumProstoy, selectIsAccumSvyazZ, selectIsManageAccumLink, selectMobileAccumulators, selectTetheringIsLow } from "../Mobile/store";
import { AddAccumButton } from "../../AddAccumButton";
var _AccumulatorList = function _AccumulatorList(_ref) {
  var accumulators = _ref.accumulators,
    tariffUrl = _ref.tariffUrl,
    isProstoy = _ref.isProstoy,
    isSvyazZ = _ref.isSvyazZ,
    userType = _ref.userType,
    services = _ref.services,
    mainCtn = _ref.mainCtn,
    tetheringIsLow = _ref.tetheringIsLow,
    hasTetheringUnlimit = _ref.hasTetheringUnlimit;
  var accumulatorVariant = getAccumulatorVariant({
    isProstoy: isProstoy,
    isSvyazZ: isSvyazZ
  });
  var TextContentComponent = getAccumulatorTextContent(accumulatorVariant);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenModal = _useState2[0],
    setModalState = _useState2[1];
  var isElkUnlimAccum3HoursEnabled = elkPlanBUnlimAccum3HoursEnabled();
  useEffect(function () {
    var hasGiftAccum = getHasGiftAccumulator(accumulators);
    var hasGiftCookie = getCookie(GIFT_VIEW_COOKIE);
    if (!hasGiftCookie && hasGiftAccum) {
      setCookie({
        name: GIFT_VIEW_COOKIE,
        value: 'true'
      });
    }
  }, []);
  var hasGiftAccum = getHasGiftAccumulator(accumulators);
  var _useState3 = useState(getCookie(GIFT_VIEW_COOKIE) === 'true'),
    _useState4 = _slicedToArray(_useState3, 2),
    showGiftAccum = _useState4[0],
    setShowGiftAccum = _useState4[1];
  useCustomEvent('showGiftAccumulator', setShowGiftAccum);
  var handleIconCloseClick = function handleIconCloseClick(e) {
    e.preventDefault();
    setShowGiftAccum(false);
    setCookie({
      name: GIFT_VIEW_COOKIE,
      value: 'false'
    });
    dispatchHideGiftAccumulatorEvent();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CommonAccumulatorList, {
    accumulators: accumulators,
    handleIconCloseClick: handleIconCloseClick,
    hasGiftAccum: hasGiftAccum,
    hasTethering: hasTetheringUnlimit,
    services: services,
    showGiftAccum: showGiftAccum,
    tetheringIsLow: tetheringIsLow,
    "data-t-id": "ConnectionBlock-AccumulatorList"
  }, function (_ref2) {
    var _services$unlimited;
    var accumulator = _ref2.accumulator,
      isInline = _ref2.isInline;
    var unlimitedButtonType = getUnlimitedAccumulatorButtonType({
      accumulator: accumulator,
      services: services,
      accumulatorVariant: accumulatorVariant,
      tetheringIsLow: tetheringIsLow
    });
    var hasButton = accumulator.isUnlimited && !!unlimitedButtonType || !!accumulator.replenishButtonType;
    return /*#__PURE__*/React.createElement(Accumulator, {
      accumulator: accumulator,
      buttonSlot: /*#__PURE__*/React.createElement(AddAccumButton, {
        accumulator: accumulator,
        isSvyazZ: isSvyazZ,
        onClick: function onClick() {
          setModalState(true);
        },
        services: services,
        tariffUrl: tariffUrl,
        unlimitedButtonType: unlimitedButtonType,
        userType: userType
      }),
      hasButton: hasButton,
      hideProgress: accumulator.size === undefined || accumulator.isUnlimited && (!isElkUnlimAccum3HoursEnabled || isElkUnlimAccum3HoursEnabled && accumulator.isUnlimited && !!(services !== null && services !== void 0 && services.unlimited3) && (services === null || services === void 0 || (_services$unlimited = services.unlimited3) === null || _services$unlimited === void 0 ? void 0 : _services$unlimited.status) === UnlimThreeStatus.ACTIVE),
      isInline: isInline,
      isMobile: true
    }, /*#__PURE__*/React.createElement(TextContentComponent, {
      accumulator: accumulator,
      isInline: isInline,
      isMobile: true,
      mainCtn: mainCtn,
      onMetricView: function onMetricView(data) {
        return fubMetricSideMenu.handleUnlimAccumulatorTextView(data);
      },
      services: services,
      tetheringIsLow: tetheringIsLow,
      userType: userType
    }));
  }), /*#__PURE__*/React.createElement(UnlimitedAppModal, {
    action: function action() {
      return fubMetricSideMenu.handleUnlimAccumulatorView(userType || '');
    },
    image: UNLIM_MODAL.IMAGE,
    isOpen: isOpenModal,
    onClose: function onClose() {
      return setModalState(false);
    },
    qrCode: UNLIM_MODAL.QR_CODE,
    subtitle: UNLIM_MODAL.SUBTITLE,
    text: UNLIM_MODAL.TEXT,
    title: UNLIM_MODAL.TITLE
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var accumulators = selectMobileAccumulators(state);
  return {
    accumulators: accumulators,
    tariffUrl: selectIsManageAccumLink(state),
    isSvyazZ: selectIsAccumSvyazZ(state),
    isProstoy: selectIsAccumProstoy(state),
    userType: selectAccountType(state),
    services: selectAccumService(state),
    mainCtn: selectAccumMainCtn(state),
    shouldRender: !!accumulators.length,
    tetheringIsLow: selectTetheringIsLow(state),
    hasTetheringUnlimit: selectHasTetheringUnlimit(state)
  };
};
var connector = connect(mapStateToProps);
export var AccumulatorList = compose(connector, withRenderFlag)(_AccumulatorList);